module.exports = __webpack_public_path__ + "static/media/0322_IMG_EN_CUISINE.7f4d97b6.png";